import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { StyledText, StyledTextSub } from 'src/components/StyledTypography';
import { useDateTimeFormatter } from 'src/hooks/dateTimeFormatter';

export default function DateEditStack(
  props: Readonly<{
    date: string;
    name: 'Effective' | 'Expiration' | null;
    role: boolean;
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
    setDatePickerType: React.Dispatch<
      React.SetStateAction<'Effective' | 'Expiration' | null>
    >;
    status?: string;
    title: string;
  }>
) {
  const formatDateTime = useDateTimeFormatter();
  return (
    <Stack>
      <StyledText fontWeight={600}>{formatDateTime(props.date)}</StyledText>
      <Stack direction="row">
        <StyledTextSub>{props.title}</StyledTextSub>
        {props.role ? (
          <IconButton
            data-testid={`gds-vp-ss-header-${props.name}`}
            disabled={props.status === 'Deactivated'}
            onClick={(event) => {
              props.setAnchorEl(event.currentTarget);
              props.setDatePickerType(props.name);
            }}
            sx={(theme) => ({ padding: `0 ${theme.spacing(0.5)}` })}
          >
            <EditIcon
              sx={(theme) => ({
                color:
                  props.status === 'Deactivated'
                    ? 'disabled'
                    : theme.palette.primary[700],
                fontSize: theme.typography.pxToRem(18),
              })}
            />
          </IconButton>
        ) : null}
      </Stack>
    </Stack>
  );
}
